import { Card, Col, Row, Slider, Typography } from "antd";

export const DevBoostStageCard = ({
    title,
    impact,
    example,
    optimizationRange
}) => (
    <Card
        title={<Typography.Title level={5}>{title}</Typography.Title>}
        style={{
            minHeight: 250,
            display: "flex",
            flexDirection: "column",
            borderRadius: 20,
            padding: 0
        }}
        styles={{
            body: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "0 24px"
            }
        }}
    >
        <Row>
            <Col span={24} style={{ textAlign: "left" }}>
                <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "0.9rem" }}>
                    ¿Cómo ayudó Copilot?:
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                    {impact}
                </Typography.Text>
            </Col>
        </Row>
        <Row>
            <Col span={24} style={{ textAlign: "left" }}>
                <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "0.9rem" }}>
                    Ejemplo concreto:
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                    {example}
                </Typography.Text>
            </Col>
        </Row>
        <Row style={{ marginTop: 0 }}>
            <Col>
                <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "0.9rem" }}>
                    Rango de optimización:
                </Typography.Text>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
                <Typography.Text style={{ fontWeight: 600, marginLeft: 8, color: "#888" }}>
                    {optimizationRange
                        ? `De ${optimizationRange[0]}% a ${optimizationRange[1]}%`
                        : ""}
                </Typography.Text>
                <Slider
                    readonly
                    range
                    min={0}
                    max={100}
                    value={optimizationRange}
                    tooltip={{ formatter: value => `${value}%` }}
                    marks={{
                        0: "0%",
                        25: "25%",
                        50: "50%",
                        75: "75%",
                        100: "100%"
                    }}
                />
            </Col>
        </Row>
    </Card>
);